import { Alert } from "antd";
import React from "react";
import { getDeclinedWord, objEstablish, objtTakeOff, typeMassActionsText } from "./constants";

const InformationBlockModal = ({ typeMassActions, count, state }) => {
  const messageFun = (type, countReq) => {
    return type + ' ' + getDeclinedWord(countReq)
  }

  const { toggleText, ...signs } = state || {};

  return (
    <>
      {
        typeMassActionsText.sign === typeMassActions ? (
          <div style={{display: 'flex', gap: '15px', flexDirection: 'column'}}>
            <Alert
              style={{ backgroundColor: "transparent", border: "none", boxShadow: "none" }}
              type="info"
              message={messageFun('Вы изменяете признаки', count)} 
              showIcon
              description={
                <span>
                  Обращаем ваше внимание, что данные действия нельзя отменить, по изменениям будут направлены системные уведомления.
                  <span style={{ display: "block", marginTop: "8px" }}>
                    Вы уверены, что хотите продолжить?
                  </span>
                </span>
              }
            />
            {Object.keys(signs)
              .filter((key) => signs[key] === true)
              .map((sign) => (
                <Alert key={sign} style={{ backgroundColor: "transparent", boxShadow: "none" }} message={toggleText === 'Установить' ? objEstablish[sign] : objtTakeOff[sign]} type="info" showIcon />
              ))
            }
          </div>
        ) : (
          <Alert showIcon message={messageFun(typeMassActions, count)} style={{ backgroundColor: "transparent", border: "none", boxShadow: "none" }} type="info"  description={
            <span>
              Обращаем ваше внимание, что данные действия нельзя отменить, по изменениям будут направлены системные уведомления.
              <span style={{ display: "block", marginTop: "8px" }}>
                Вы уверены, что хотите продолжить?
              </span>
            </span>
          }/>
        )
      }
    </>

  )
}

export default InformationBlockModal;
